export default __webpack_public_path__ + "static/media/maintenanceBackground.aded4ba4.png";